module.exports = __webpack_public_path__ + "img/fenstergitter.4f9edcda.jpg";